<template>
	<auth-layout title="创建账号" subtitle="填写信息完成注册" brand-desc="加入新通，开启高效沟通"
		:tags="['快速注册', '安全加密', '即时畅聊']">
		<el-form class="auth-form register-form" :model="dataForm" status-icon :rules="rules" ref="registerForm"
			label-width="80px" @keyup.enter.native="submitForm()">
			<el-form-item v-if="dataForm.mode == 'phone'" label="手机号码" prop="phone">
				<el-input v-model="dataForm.phone" autocomplete="off" placeholder="手机号码" maxLength="11" clearable></el-input>
			</el-form-item>
			<el-form-item v-if="dataForm.mode == 'username'" label="用户名" prop="userName">
				<el-input v-model="dataForm.userName" autocomplete="off" placeholder="用户名" maxLength="50" clearable></el-input>
			</el-form-item>
			<el-form-item v-if="dataForm.mode == 'email'" label="邮箱" prop="email">
				<el-input v-model="dataForm.email" autocomplete="off" placeholder="邮箱"></el-input>
			</el-form-item>
			<el-form-item v-show="dataForm.mode == 'email'" label="验证码" prop="code">
				<el-input v-model="dataForm.code" autocomplete="off" placeholder="验证码">
					<div v-if="emailLockTime > 0" slot="append">{{ `${emailLockTime}秒后重新获取` }}</div>
					<el-button v-else slot="append" @click="onLoadMailCaptcha">获取验证码</el-button>
				</el-input>
			</el-form-item>
			<el-form-item label="昵称" prop="nickName">
				<el-input type="nickName" v-model="dataForm.nickName" autocomplete="off"
					placeholder="昵称" maxLength="50" clearable></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="password">
				<el-input type="password" v-model="dataForm.password" autocomplete="off"
					placeholder="密码" clearable></el-input>
			</el-form-item>
			<el-form-item label="确认密码" prop="confirmPassword">
				<el-input type="password" v-model="dataForm.confirmPassword" autocomplete="off"
					placeholder="确认密码" clearable></el-input>
			</el-form-item>
			<el-form-item label-width="0">
				<div class="form-actions">
					<el-button type="primary" :loading="loading" :disabled="loading" @click="submitForm()">注 册</el-button>
					<el-button :disabled="loading" @click="resetForm()">重 置</el-button>
				</div>
				<div class="form-footer">
					<span></span>
					<router-link to="/login">已有账号？去登录</router-link>
				</div>
			</el-form-item>
		</el-form>
	</auth-layout>
</template>

<script>
import AuthLayout from '@/components/common/AuthLayout.vue';

export default {
	name: "register",
	components: { AuthLayout },
	data() {
		var checkPhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入手机号码'));
			}
			const regex = /^1[3-9]\d{9}$/;
			if (!regex.test(value)) {
				return callback(new Error('手机号格式错误'));
			}
			callback();
		};
		var checkEmail = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入邮箱'));
			}
			const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
			if (!regex.test(value)) {
				return callback(new Error('邮箱格式错误'));
			}
			callback();
		};
		var checkUserName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入用户名'));
			}
			callback();
		};
		var checkNickName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入昵称'));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			callback();
		};
		var checkConfirmPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			if (value != this.dataForm.password) {
				return callback(new Error('两次密码输入不一致'));
			}
			callback();
		};
		return {
			dataForm: {
				phone: '',
				email: '',
				code: '',
				mode: 'phone',
				userName: '',
				nickName: '',
				password: '',
				confirmPassword: '',
				terminal: this.$enums.TERMINAL_TYPE.WEB,
			},
			loading: false,
			rules: {
				phone: [{
					validator: checkPhone,
					trigger: 'blur'
				}],
				email: [{
					validator: checkEmail,
					trigger: 'blur'
				}],
				userName: [{
					validator: checkUserName,
					trigger: 'blur'
				}],
				nickName: [{
					validator: checkNickName,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}],
				confirmPassword: [{
					validator: checkConfirmPassword,
					trigger: 'blur'
				}]
			},
			emailLockTime: 0,
			emailLockTimer: null,
			modeNameMap: {
				username: "用户名注册",
				phone: "手机号注册",
				email: "邮箱注册"
			}
		};
	},
	methods: {
		getLoginUserName() {
			if (this.dataForm.mode === 'phone') {
				return this.dataForm.phone;
			}
			if (this.dataForm.mode === 'email') {
				return this.dataForm.email;
			}
			return this.dataForm.userName;
		},
		setCookie(name, value) {
			document.cookie = name + "=" + escape(value);
		},
		loginAfterRegister() {
			const userName = this.getLoginUserName();
			const password = this.dataForm.password;
			return this.$http({
				url: "/login",
				method: 'post',
				data: {
					terminal: this.dataForm.terminal,
					userName,
					password
				}
			}).then((data) => {
				this.setCookie('username', userName);
				this.setCookie('password', password);
				sessionStorage.setItem("accessToken", data.accessToken);
				sessionStorage.setItem("refreshToken", data.refreshToken);
				this.$message.success("注册成功，已自动登录");
				this.$router.push("/home/chat");
			}).catch(() => {
				this.$message.success("注册成功，请登录");
				this.$router.push("/login");
			});
		},
		submitForm() {
			if (this.loading) {
				return;
			}
			this.$refs.registerForm.validate((valid) => {
				if (valid) {
					this.loading = true;
					this.$http({
						url: "/register",
						method: 'post',
						data: this.dataForm
					}).then(() => {
						return this.loginAfterRegister();
					}).finally(() => {
						this.loading = false;
					});
				}
			});
		},
		onLoadMailCaptcha() {
			this.$refs.registerForm.validateField('email', (valid) => {
				if (valid == '') {
					this.emailLockTime = 60;
					this.emailLockTimer && clearInterval(this.emailLockTimer);
					this.emailLockTimer = setInterval(() => {
						this.emailLockTime -= 1;
						if (this.emailLockTime <= 0) {
							this.emailLockTimer && clearInterval(this.emailLockTimer);
						}
					}, 1000)
					let data = {
						email: this.dataForm.email,
					}
					this.$http({
						url: "/captcha/mail/code",
						method: 'post',
						data: data
					}).then(() => {
						this.$message.success("验证码已发送至您的邮箱，请注意查收")
					})
				}
			})
		},
		switchMode(mode) {
			this.dataForm.mode = mode;
			this.resetForm();
		},
		resetForm() {
			this.$refs.registerForm.resetFields();
		}
	},
	computed: {
		config() {
			return this.$store.state.configStore.registration;
		}
	},
	watch: {
		config: {
			handler() {
				if (this.config.mode && this.config.mode[0]) {
					this.switchMode(this.config.mode[0]);
				}
			}
		}
	},
	mounted() {
		if (this.config.mode && this.config.mode[0]) {
			this.switchMode(this.config.mode[0]);
		}
	}
}
</script>

<style scoped lang="scss">
@import '@/assets/style/auth-form.scss';

.register-form {
	::v-deep .el-form-item__content {
		.form-footer {
			margin-top: 4px;
		}
	}
}
</style>
